import { extendTheme } from "@chakra-ui/react";
import colors from "./colors";

const theme = extendTheme({
    colors,
    fonts: {
        heading: "'Ubuntu', sans-serif",
        body: "'Ubuntu', sans-serif",
    },
    components: {
        Button: {
            baseStyle: {
                borderRadius: 0,
                fontWeight: 600,
                fontFamily: 'Poppins',
            },
        },
        Input: {
            baseStyle: {
                field: {
                    bg: 'white',
                    borderRadius: 0,
                    borderColor: '#9D9D9D',
                },
            },
        },
        Table: {
            baseStyle: {
                th: {
                    fontWeight: '700',
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                },
                td: {
                    fontFamily: 'Rubik',
                },
            },
        },
    }
});

export default theme;



